module.exports = __webpack_public_path__ + "static/media/ageing-crisis.a9c754d0.jpg";